export default __webpack_public_path__ + "static/media/MP5_3.20a73e53.png";